// extracted by mini-css-extract-plugin
module.exports = {"next-sr-only":"ReleasedTable--next-sr-only--2lFPEM9","w-full":"ReleasedTable--w-full--39zM0JW"};